import React from "react";

export type Power01IconProps = {
  className?: string;
  pathClassName?: string;
};

export const Power01Icon: React.FC<Power01IconProps> = ({
  className,
  pathClassName,
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 1.66675V10.0001M15.3 5.53341C16.3487 6.58241 17.0627 7.91878 17.3519 9.37357C17.6411 10.8284 17.4924 12.3362 16.9247 13.7065C16.357 15.0768 15.3957 16.248 14.1624 17.072C12.9291 17.896 11.4791 18.3358 9.99585 18.3358C8.5126 18.3358 7.06265 17.896 5.82933 17.072C4.59602 16.248 3.63472 15.0768 3.06699 13.7065C2.49926 12.3362 2.35059 10.8284 2.63978 9.37357C2.92897 7.91878 3.64304 6.58241 4.69169 5.53341"
      stroke="#0C111D"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
